import { React, FelaComponent } from '../../dependencies';

import * as styles from './Divider.styles';

function Divider() {
    return <FelaComponent style={styles.divider} />;
}

export default Divider;
